import PropTypes from 'prop-types';
import React from 'react';
import StyledLink from './styled-link';

const sizes = ['large', 'medium', 'small'];

const propTypes = {
	centreAlign: PropTypes.bool,
	children: PropTypes.node,
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	disabled: PropTypes.bool,
	href: PropTypes.string,
	icon: PropTypes.element,
	iconRight: PropTypes.bool,
	isButton: PropTypes.bool,
	size: PropTypes.oneOfType([
		PropTypes.oneOf(sizes),
		PropTypes.shape(
			['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(
				(acc, current) => ({ ...acc, [current]: PropTypes.oneOf(sizes) }),
				{},
			),
		),
	]),
	standalone: PropTypes.bool,
	underline: PropTypes.bool,
	white: PropTypes.bool,
};
const defaultProps = {
	centreAlign: false,
	children: null,
	className: undefined,
	dataTestId: null,
	disabled: undefined,
	href: undefined,
	icon: undefined,
	iconRight: false,
	isButton: false,
	size: 'large',
	standalone: false,
	underline: true,
	white: false,
};

export function Link({ className, dataTestId, disabled, href, isButton, ...props }) {
	return (
		<StyledLink
			aria-disabled={disabled ? true : undefined}
			as={isButton ? 'button' : undefined}
			className={className ? `fuse-link ${className}` : `fuse-link`}
			data-testid={dataTestId}
			href={disabled || isButton ? undefined : href}
			isButton={isButton}
			role={isButton ? 'button' : 'link'}
			focusable
			{...props}
		/>
	);
}

Link.propTypes = propTypes;
Link.defaultProps = defaultProps;
Link.displayName = 'Link';

export default Link;
